import type { ReactNode } from "react";
import { formatarReais } from "../formatos";
import { IconeAlerta, IconeRelogio } from "../icones";

/** A conta do repasse (spec 048): o bruto lido na Nelogica, a taxa da MTC sobre ele e o IR sobre o que sobra. */
export type ContaDoRepasse = {
  bruto_centavos: number;
  /** Pontos-base: 1000 = 10%. */
  taxa_mtc_pb: number;
  ir_pb: number;
  taxa_mtc_centavos: number;
  ir_centavos: number;
  liquido_centavos: number;
};

/** 1000 pontos-base -> "10%"; 1250 -> "12,5%". */
export const percentualDePb = (pb: number) => `${(pb / 100).toLocaleString("pt-BR", { maximumFractionDigits: 2 })}%`;

/**
 * A conta na ordem da planilha da operacao: bruto, taxa da MTC, IR e o que o cliente recebe. A mesma peca no painel (pra
 * conferir antes de mandar) e na area (pro cliente confirmar), pra os dois lerem exatamente a mesma conta.
 */
export function ContaDoRepasse({ conta, rotuloDoLiquido = "Você recebe" }: { conta: ContaDoRepasse; rotuloDoLiquido?: string }) {
  return (
    <dl className="mtc-conta-repasse">
      <div className="mtc-conta-repasse__linha"><dt>Valor bruto na Mesa Real</dt><dd className="mtc-mono">{formatarReais(conta.bruto_centavos)}</dd></div>
      <div className="mtc-conta-repasse__linha mtc-conta-repasse__linha--desconto"><dt>Taxa da MTC ({percentualDePb(conta.taxa_mtc_pb)})</dt><dd className="mtc-mono">{formatarReais(conta.taxa_mtc_centavos)}</dd></div>
      <div className="mtc-conta-repasse__linha mtc-conta-repasse__linha--desconto"><dt>IR ({percentualDePb(conta.ir_pb)} sobre o que sobra)</dt><dd className="mtc-mono">{formatarReais(conta.ir_centavos)}</dd></div>
      <div className="mtc-conta-repasse__linha mtc-conta-repasse__linha--total"><dt>{rotuloDoLiquido}</dt><dd className="mtc-mono">{formatarReais(conta.liquido_centavos)}</dd></div>
    </dl>
  );
}

/**
 * O que ninguem pode deixar de ver (spec 048): o prazo do lembrete pos-repasse e o "remova o perfil de risco" do pedido
 * novo. Maior e mais forte que o `Aviso`, de proposito: o Vitor pediu "notificacao grande".
 */
export function Destaque({ tom = "erro", icone, rotulo, titulo, children }: { tom?: "erro" | "alerta"; icone?: "relogio" | "alerta"; rotulo: string; titulo: ReactNode; children?: ReactNode }) {
  const Icone = icone === "relogio" ? IconeRelogio : IconeAlerta;
  return (
    <div className={`mtc-destaque mtc-destaque--${tom}`} role="note" aria-label={rotulo}>
      <Icone tamanho={26} />
      <div className="mtc-destaque__corpo">
        <span className="mtc-destaque__rotulo">{rotulo}</span>
        <strong className="mtc-destaque__titulo">{titulo}</strong>
        {children && <span className="mtc-destaque__texto">{children}</span>}
      </div>
    </div>
  );
}
